import { useEffect } from "react";

const SHORTCUT_KEY = "k";

/** ⌘K / Ctrl+K opens the advisor from anywhere in the shell (the Desktop v3 nav advertises it). */
export const useAdvisorShortcut = (open: () => void) => {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key.toLowerCase() !== SHORTCUT_KEY || !(event.metaKey || event.ctrlKey)) return;
			event.preventDefault();
			open();
		};
		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [open]);
};
